import { TimeDataResponse, MassagedUserData, GenericStringKeyList, UserDataResponse, UsersType, UserSubSectionNumber, SingleDataObject, NameValuePair } from "../../Types/DataTypes";
import { keysToDisplay } from "../../DataConstants/CirclyAnalyticsConstants";
import { exclude } from "../../DataConstants/TimeDataConstants";

export const massageUserData = (data:UserDataResponse) => {
    const usersObject : UsersType = data["users"] as UsersType
    const massaged: MassagedUserData = {
        allUserSkillData: [],
        allUserInventories: [],
        allUserAvatarUrls: [],
        skillList: [],
    }
    Object.keys(usersObject).forEach(userName => {
        massaged.allUserSkillData.push(
            {
                name: userName,
                skills: usersObject[userName]["levels"] as UserSubSectionNumber
            }
        )
        massaged.allUserInventories.push(
            {
                name: userName,
                items: usersObject[userName]["items"] as UserSubSectionNumber
            }
        )
        massaged.allUserAvatarUrls.push(
            {
                name: userName,
                avatar: usersObject[userName]["USER_PROFILE_IMAGE"] as string
            }
        )
    })
    massaged.skillList = Object.keys(massaged.allUserSkillData[0].skills)
    return massaged;
}

const calculateDifference = (
    data: TimeDataResponse,
    keys: GenericStringKeyList,
    lastEntryIndex: number,
    currentKey: string,
    recent: boolean,
    recentDivisor: number
) => {
    const totalEntries = lastEntryIndex + 1;
    const subtractAmount = totalEntries / recentDivisor;
    return recent
        ? data[keys[lastEntryIndex]][currentKey] -
              data[keys[lastEntryIndex - subtractAmount]][currentKey]
        : data[keys[lastEntryIndex]][currentKey] - data[keys[0]][currentKey];
};

const calculatePercentage = (
    data: TimeDataResponse,
    keys: GenericStringKeyList,
    lastEntryIndex: number,
    currentKey: string,
    totalDifference: number,
    recentDifference: number
) => {
    return data[keys[lastEntryIndex]][currentKey] === data[keys[0]][currentKey]
        ? 0
        : (recentDifference / totalDifference) * 100;
};

export const calcualtePercentages = (data:TimeDataResponse) => {
    const totalDataEntries: number = Object.keys(data).length;
            let timestampedDataKeys: GenericStringKeyList =
                Object.keys(data);
            return keysToDisplay.map((keyToDisplay) => {
                const difference: number = calculateDifference(
                    data,
                    timestampedDataKeys,
                    totalDataEntries - 1,
                    keyToDisplay,
                    false,
                    0
                );
                const recentDifference: number = calculateDifference(
                    data,
                    timestampedDataKeys,
                    totalDataEntries - 1,
                    keyToDisplay,
                    true,
                    4
                );
                return calculatePercentage(
                    data,
                    timestampedDataKeys,
                    totalDataEntries - 1,
                    keyToDisplay,
                    difference,
                    recentDifference
                );
            });
}

export const masasgeTimeData = (data: TimeDataResponse) => {
    const timeKeys: GenericStringKeyList = Object.keys(data);
    const finalObject: SingleDataObject = data[timeKeys[timeKeys.length - 1]];
    const finalObjectKeys: GenericStringKeyList = Object.keys(finalObject);

    return finalObjectKeys.map((key: string) => {
        return {
            name: key,
            value: finalObject[key],
        };
    }).filter(
        (value: NameValuePair) =>
            !exclude.includes(value.name)
    );
}